import * as React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import Slider, { SliderThumb } from '@material-ui/core/Slider';
import { experimentalStyled as styled } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

const Root = styled('div')(
  ({ theme }) => `
  width: 100%;
`,
);

const Separator = styled('div')(
  ({ theme }) => `
  height: ${theme.spacing(3)};
`,
);

function ValueLabelComponent(props) {
  const { children, value } = props;

  return (
    <Tooltip enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  value: PropTypes.number.isRequired,
};

const marks = [
  {
    value: 0,
    label: '1w',
  },
  {
    value: 100,
    label: '2w',
  },
];

const iOSBoxShadow =
  '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';



const IOSSlider = styled(Slider)({
  color: '#3880ff',
  height: 2,
  padding: '15px 0',
  '& .MuiSlider-thumb': {
    height: 28,
    width: 28,
    backgroundColor: '#fff',
    boxShadow: iOSBoxShadow,
    marginTop: -14,
    marginLeft: -14,
    '&:focus, &:hover, &.Mui-active': {
      boxShadow:
        '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        boxShadow: iOSBoxShadow,
      },
    },
  },
  '& .MuiSlider-valueLabel': {
    left: 'calc(-50% + 12px)',
    top: -22,
    '& *': {
      background: 'transparent',
      color: '#000',
    },
  },
  '& .MuiSlider-track': {
    height: 2,
  },
  '& .MuiSlider-rail': {
    height: 2,
    opacity: 0.5,
    backgroundColor: '#bfbfbf',
  },
  '& .MuiSlider-mark': {
    backgroundColor: '#bfbfbf',
    height: 8,
    width: 1,
    marginTop: -3,
    '&.MuiSlider-markActive': {
      opacity: 1,
      backgroundColor: 'currentColor',
    },
  },
});

const PrettoSlider = styled(Slider)({
  color: '#52af77',
  height: 8,
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &.Mui-active': {
      boxShadow: 'inherit',
    },
  },
  '& .MuiSlider-valueLabel': {
    left: 'calc(-50% + 4px)',
  },
  '& .MuiSlider-track': {
    height: 8,
    borderRadius: 4,
  },
  '& .MuiSlider-rail': {
    height: 8,
    borderRadius: 4,
  },
});

function valuetext(value) {
  console.log(value)
  let val = value === 0 ? value + 1 : value
  console.log(val)
  return `${val} Week`;
}

const CustomizedSlider = ({STEP, MIN, MAX, handleValue, def}) =>  {
  const [values, setValues] = useState(def)

  React.useEffect(() => {
    handleValue(values)
  }, [values])
  return (
    <Root>
      {/* <Typography gutterBottom>iOS</Typography>
      <Separator />
      <IOSSlider
        aria-label="ios slider"
        defaultValue={1}
        getAriaValueText={valuetext}
        valueLabelFormat={valuetext}
        step={100}
        marks={marks}
        valueLabelDisplay="on"
      /> */}
      <Separator />
      <PrettoSlider
        valueLabelDisplay="on"
        aria-label="pretto slider"
        defaultValue={def}
        min={MIN}
        step={STEP}
        max={MAX}
        value={values}
        onChange={(e) => setValues(e.target.value)}
      />
    </Root>
  );
}


export default CustomizedSlider